export default "__VITE_ASSET__CQdeG5mp__"